// Bookmarks.jsx
import React from "react";
import styles from "./Bookmarks.module.css"; // Import the CSS module

const Bookmarks = ({ bookmarks, handleRemoveBookmark }) => {
  return (
    <div className={styles.bookmarksContainer}>
      <h2 className={styles.title}>Bookmarks</h2>
      {bookmarks.length > 0 ? (
        bookmarks.map((bookmark) => (
          <div key={bookmark.id} className={styles.bookmarkCard}>
            <h3 className={styles.bookmarkTitle}>{bookmark.title}</h3>
            <p className={styles.bookmarkBody}>{bookmark.body}</p>
            <button
              className={`${styles.button} ${styles.removeButton}`}
              onClick={() => handleRemoveBookmark(bookmark)}
            >
              Remove
            </button>
          </div>
        ))
      ) : (
        <p className={styles.noBookmarks}>No bookmarks available.</p>
      )}
    </div>
  );
};

export default Bookmarks;
